

export const isDesktopSize ="(min-width: 1024px)";